import { createWorkerTsDemuxerMainHandler } from '@mimir/common/mpegts/workerMainHandler';
import type { Logger } from '@mimir/common/types/logger';
import type { MpegTsDemuxMainToWorkerMessage, MpegTsDemuxWorkerToMainMessage } from '@mimir/common/mpegts/workerProtocol';
import type { EncodedData } from '@mimir/common/mpegts/demuxerTypes';

export interface AsyncTsDemuxer {
  demuxTs: (bytes: Uint8Array) => Promise<EncodedData>;
  close: () => void;
}

export function createAsyncTsDemuxer(
  services: {
    logger: Logger
  },
  workerProcessorUrl: string,
): AsyncTsDemuxer {
  const worker = new Worker(workerProcessorUrl, { type: 'module' });

  const handler = createWorkerTsDemuxerMainHandler(
    services,
    (message: MpegTsDemuxMainToWorkerMessage, transfer: Transferable[]) => {
      worker.postMessage(message, { transfer });
    },
    (): void => {
      worker.terminate();
    }
  );

  worker.onmessage = (message: MessageEvent<MpegTsDemuxWorkerToMainMessage>) => {
    handler.handleMessage(message.data);
  };

  return handler;
}
